import { environment } from 'env/environment';
import { Injectable } from '@angular/core';

// Use a union type for allowed feature names and direct property access for type safety.
export type FeatureFlagName = 'customActivities' | 'qrCodeLogin';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  public isFeatureOff(featureName: FeatureFlagName): boolean {
    const hasFeatureProperty = Object.prototype.hasOwnProperty.call(environment.featureFlags, featureName);

    if (hasFeatureProperty) {
      return !environment.featureFlags[featureName];
    }

    return true;
  }

  public isFeatureOn(featureName: FeatureFlagName) {
    return !this.isFeatureOff(featureName);
  }
}
